const debug = require('debug')('ccs:router');

import Vue from 'vue';
import VueRouter from 'vue-router';

import ConsoleController from './layout/console.vue';

import TemplateController from './controllers/template.vue';
import TemplatePreviewController from './controllers/template_preview.vue';
import TemplateCodesController from './controllers/template_codes.vue';

import UnitTestController from './controllers/unit_test.vue';
import UnitTestControllerAdd from './controllers/unit_test_add.vue';
import UnitTestControllerEdit from './controllers/unit_test_edit.vue';
import UserRoleCheckController from './controllers/unit_test_check.vue';

import RoleController from './controllers/role.vue';
import RoleAddController from './controllers/role_add.vue';
import RoleEditController from './controllers/role_edit.vue';
import RolePreviewController from './controllers/role_preview.vue';
import UserRoleController from './controllers/user_role.vue';
import UserRoleAddController from './controllers/user_role_add.vue';
import UserRoleEditController from './controllers/user_role_edit.vue';

import TipAudioController from './controllers/tip_audio.vue';
import PreviewController from './controllers/preview.vue';
import PreviewControllerAdd from './controllers/preview_add.vue';
import PreviewControllerEdit from './controllers/preview_edit.vue';
import PreviewCheckController from './controllers/preview_check.vue';
import ReviewController from './controllers/review/review.vue';
import ReviewControllerAdd from './controllers/review/review_add.vue';
import ReviewControllerEdit from './controllers/review/review_edit.vue';
import ReviewCheckController from './controllers/review/review_check.vue';
import UpgradeController from './controllers/upgrade_test.vue';
import UpgradeControllerAdd from './controllers/upgrade_test_add.vue';
import UpgradeControllerEdit from './controllers/upgrade_test_edit.vue';
import UpgradeCheckController from './controllers/upgrade_test_check.vue';

import LangtestController from './controllers/langtest/langtest.vue';
import LangtestControllerAdd from './controllers/langtest/langtest_add.vue';
import LangtestControllerEdit from './controllers/langtest/langtest_edit.vue';
import LangtestCheckController from './controllers/langtest/langtest_check.vue';


// Vue.use(VueRouter);

const routes = [
	{
		path: '/console', component: ConsoleController,
		children: [
			{
				name: 'templates',
				path: 'templates',
				component: TemplateController
			},
			{
				name: 'templatePreview',
				path: 'templates/:templateId(\\d+)/preview',
				component: TemplatePreviewController
			},
			{
				name: 'templateCodes',
				path: 'templates/:templateId(\\d+)/codes',
				component: TemplateCodesController
			},
			{
				name: 'unitTest',
				path: 'papers/ut',
				component: UnitTestController
			},
			{
				name: 'unitTestAdd',
				path: 'papers/ut/:unitId(\\d+)/add',
				component: UnitTestControllerAdd
			},
			{
				name: 'unitTestEdit',
				path: 'papers/ut/:unitId(\\d+)/edit',
				component: UnitTestControllerEdit
			},
			{
				name: 'unitTestCheck',
				path: 'papers/ut/:unitId(\\d+)/check',
				component: UserRoleCheckController
			},
			{
				name: 'roles',
				path: 'roles',
				component: RoleController,
			},
			{
				name: 'rolesAdd',
				path: 'roles/add',
				component: RoleAddController
			},
			{
				name: 'roleEdit',
				path: 'roles/:roleId(\\d+)/edit',
				component: RoleEditController
			},
			{
				name: 'rolePreview',
				path: 'roles/:roleId(\\d+)/preview',
				component: RolePreviewController
			},
			{
				name: 'userRoles',//角色分配
				path: 'userRoles',
				component: UserRoleController
			},
			{
				name: 'userRolesAdd',
				path: 'userRoles/add',
				component: UserRoleAddController
			},
			{
				name: 'userRolesEdit',
				path: 'userRoles/:username/edit',
				component: UserRoleEditController
			},
			{
				name: 'tipAudio',
				path: 'tipAudios',
				component: TipAudioController
			},
			{
				name: 'preview',
				path: 'papers/preview',
				component: PreviewController
			},
			{
				name: 'previewAdd',
				path: 'papers/preview/:courseId(\\d+)/add',
				component: PreviewControllerAdd
			},
			{
				name: 'previewEdit',
				path: 'papers/preview/:courseId(\\d+)/edit',
				component: PreviewControllerEdit
			},
			{
				name: 'previewCheck',
				path: 'papers/preview/:courseId(\\d+)/check',
				component: PreviewCheckController
			},
			{
				name: 'review',
				path: 'papers/review',
				component: ReviewController
			},
			{
				name: 'reviewAdd',
				path: 'papers/review/:courseId(\\d+)/add',
				component: ReviewControllerAdd
			},
			{
				name: 'reviewEdit',
				path: 'papers/review/:courseId(\\d+)/edit',
				component: ReviewControllerEdit
			},
			{
				name: 'reviewCheck',
				path: 'papers/review/:courseId(\\d+)/check',
				component: ReviewCheckController
			},
			{
				name: 'upgrade',
				path: 'papers/upgrade',
				component: UpgradeController
			},
			{
				name: 'upgradeAdd',
				path: 'papers/upgrade/:levelId(\\d+)/add',
				component: UpgradeControllerAdd
			},
			{
				name: 'upgradeEdit',
				path: 'papers/upgrade/:levelId(\\d+)/edit',
				component: UpgradeControllerEdit
			},
			{
				name: 'upgradeCheck',
				path: 'papers/upgrade/:levelId(\\d+)/check',
				component: UpgradeCheckController
			},
			{
				name: 'langtest',
				path: 'papers/langtest',
				component: LangtestController
			},
			{
				name: 'langtestAdd',
				path: 'papers/langtest/:courseId(\\d+)/add',
				component: LangtestControllerAdd
			},
			{
				name: 'langtestEdit',
				path: 'papers/langtest/:courseId(\\d+)/edit',
				component: LangtestControllerEdit
			},
			{
				name: 'langtestCheck',
				path: 'papers/langtest/:courseId(\\d+)/check',
				component: LangtestCheckController
			},
		]
	},
	{ path: '*', redirect: '/console/papers/ut' }
];

const router = new VueRouter({
	routes
});

router.beforeEach((to, from, next) => {
	debug('from [%s] to [%s]', from, to);
	next();
});

export default router;